import PrimaryButton from "../../../../_utils/CommonButtons/PrimaryButton";
import Loader from "../../../../Loader/Index";

const FecthingPage = ({
  fetchPageEnabled,
  loading,
  isError,
  handleFunction,
  errorData,
}) => {
  return (
    <>
      {fetchPageEnabled || loading || errorData === 404 ? (
        <>
          <div
            className={`flex justify-center items-center  bg-primary-card ${errorData !== 404 ? " opacity-dark-opacity " : ""} absolute w-width-full h-height-full z-z-index-header rounded-b-border-radius-md`}
          ></div>
          <div className="flex flex-col absolute justify-center items-center w-width-full h-height-full z-z-index-header opacity-base-opacity">
            {errorData === 404 ? (
              <div className="flex flex-col gap-y-gap-sm mx-auto justify-center items-center">
                <img
                  className="h-graphic-rectangle-height-md w-graphic-width-md"
                  src="https://q2pay.in/new_assets/graphics/no_data/no_statistics_available.svg"
                  alt=""
                />
                <div className="text-text-primary text-font-sm font-semibold text-center">
                  <span className="block">
                    No statistics available due to the absence of data.
                  </span>
                  <span className="block">
                    Once data is present, statistics will appear.
                  </span>
                </div>
              </div>
            ) : (
              <>
                <div className="text-text-primary text-font-sm font-semibold px-padding-lg text-center">
                  {isError
                    ? "Failed to fetch for the current parameters. Change parameters or try again later."
                    : "Click below to fetch the updated statistics"}
                </div>
                <div className="mt-margin-md">
                  {loading ? (
                    <Loader
                      width="var(--icon-lg)"
                      height="var(--icon-lg)"
                    />
                  ) : (
                    <PrimaryButton
                      btnText={"Fetch"}
                      enabledTextColor={"var(--text-primary)"}
                      enabledBgColor={"var(--primary-nav-act)"}
                      handleFunction={handleFunction}
                      hoverOption="white"
                      isLoading={loading}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </>
      ) : null}
    </>
  );
};

export default FecthingPage;
